// extracted by mini-css-extract-plugin
module.exports = {"answeredTag":"AnsweredTag-answeredTag-f5a6533fa9b3d70a12f33d9dfc3d71f9","tagIcon":"AnsweredTag-tagIcon-94bdb263ca1b0f168f104a24dedad201"};